import React, { FC } from "react";

import { DateFormat, Status } from "@/components/atoms";
import { MaxLinesCell, SingleLineCell } from "@/components/molecules";
import { byteSizeFormatter } from "@/core/string";
import { Document } from "@/shared/domain";
import { StyledTableCell, StyledTableRow } from "@/styles/styled";

import { StatusColorMap } from "../utils";

export type DocumentTableItemDesktopProps = {
    document: Document;
    onClick: () => void;
};

const DocumentTableItemDesktop: FC<DocumentTableItemDesktopProps> = ({ document, onClick }) => {
    return (
        <StyledTableRow
            hover
            key={`document-${document.id}`}
            data-testid={`document_item_desktop-row-${document.id}`}
            onClick={onClick}
        >
            <MaxLinesCell testId="table-cell-description" maxLines={2} variant="main" highlight>
                {document.description}
            </MaxLinesCell>
            <MaxLinesCell testId="table-cell-secondaryDescription" maxLines={2} highlight>
                {document.secondaryDescription}
            </MaxLinesCell>
            <SingleLineCell testId="table-cell-fileSize" variant="grey" highlight>
                {`${document.documentType.name} - ${byteSizeFormatter(document.fileSize)}`}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-date" variant="grey" highlight>
                <DateFormat date={document.date} />
            </SingleLineCell>
            <StyledTableCell data-testid="table-cell-status">
                <Status color={StatusColorMap[document.status.id]} text={document.status.name} noBullet />
            </StyledTableCell>
        </StyledTableRow>
    );
};
export default DocumentTableItemDesktop;
